export default function getBrowserLanguage() {
    return navigator.language || navigator.userLanguage;
}

